import { isValidEmail } from "./types";

export const validateEmail = (email: string): string | null => {
	if (!email) return "Email is a required field";

	if (!isValidEmail(email)) return "Email must be a valid email address";

	return null;
};
